// extracted by mini-css-extract-plugin
module.exports = {"aniEGsapA1":"aniEGsapA1_aniEGsapA1__VwXQB"};